import { forwardRef } from "react";
import { bool, func, node, number, string } from "prop-types";
import { IconButton, InputBase, Tooltip } from "@material-ui/core";
import { Check, ErrorOutline } from "@material-ui/icons";
import classnames from "classnames";
import useStyle from "../TextClearInput.style";
import { NavigationDataKey } from "@tools/EstimateEditor/hooks/useNavigationKeybinds";

export const Input = forwardRef(({
  value,
  placeholder,
  error,
  errorMessage,
  minimal,
  confirmOnEnter,
  handleAccept,
  handleChange,
  handleClick,
  handleBlur,
  multiline,
  className,
  navigationKey,
  tabIndex,
  scaleWidthToContent,
  endAdornment,
  hideAcceptButton=false,
}, ref) => {
  
  const classes = useStyle();
  
  const checkKey = (e) => {
    if(e.key === "Enter" && !multiline)
      e.preventDefault();
    if (confirmOnEnter && e.key === "Enter" && !error)
      handleAccept();
    if (e.key === "Escape" && !error)
      handleAccept(true);
  };
  
  return (
    <InputBase
      minRows={1}
      multiline={multiline}
      tabIndex={tabIndex}
      inputProps={{
        className: classnames(
          classes.input,
          classes.inheritFont,
          multiline && classes.inputMultiline,
          scaleWidthToContent && classes.scaleWidthToContent,
          className,
        ),
        ref,
        ...{[NavigationDataKey]: navigationKey}
      }}
      className={classnames(
        classes.inputBase,
        classes.inheritFont,
        multiline && classes.inputBaseMultiline,
        !scaleWidthToContent && "w-full"
      )}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      onFocus={focus}
      onBlur={handleBlur}
      autoFocus
      error={error}
      onKeyDown={checkKey}
      onClick={handleClick}
      endAdornment={
        <>
          { endAdornment }
          {
            minimal
              ? undefined
              : error
                ? (
                  errorMessage
                    ?
                    <Tooltip arrow title={errorMessage}>
                      <ErrorOutline
                        color="error"
                        className="text-2xl ml-1"
                      />
                    </Tooltip>
                    : <ErrorOutline
                      color="error"
                      className="text-2xl ml-1"
                    />
                ) : (
                  !hideAcceptButton &&
                  <IconButton
                    onClick={handleAccept}
                    className="p-0 ml-1 text-2xl"
                    color="primary"
                  >
                    <Check />
                  </IconButton>
                )
          }
        </>
      }
    />
  )
})

Input.propTypes = {
  value: string,
  placeholder: string,
  className: string,
  error: bool,
  errorMessage: string,
  minimal: bool,
  confirmOnEnter: bool,
  multiline: bool,
  handleChange: func.isRequired,
  handleClick: func.isRequired,
  handleAccept: func.isRequired,
  handleBlur: func,
  navigationKey: string,
  tabIndex: number,
  scaleWidthToContent: bool,
  hideAcceptButton: bool,
  endAdornment: node,
}